export default "__VITE_ASSET__CYxN5TwW__"